import type { AccessControlProvider } from "@refinedev/core";
import { authProvider } from "./authProvider";

type PermissionData = {
  isStaff?: boolean;
  isSuperuser?: boolean;
};

export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource }) => {
    if (resource === "health") {
      const permissions = (await authProvider.getPermissions?.()) as
        | PermissionData
        | undefined;
      const can = Boolean(permissions?.isStaff || permissions?.isSuperuser);
      return {
        can,
        reason: can ? undefined : "Staff access required",
      };
    }
    return { can: true };
  },
};
